import React, { useEffect, useState } from "react";
import { GlobalStore } from "../../stores/global";
import { Link } from "react-router-dom";
import { slugToCountryPathname } from "../../utils/strings";
import { CloseIcon } from "@speedoc/design-assets/build/icons/index";

export default function TopBanner() {
  const countryCode = GlobalStore.useState(s => s.currentCountryCode);
  const countries = GlobalStore.useState(s => s.countries);
  const closeTopBanner = GlobalStore.useState(s => s.closeTopBanner);
  const [content, setContent] = useState(null);

  useEffect(() => {
    const country = countries.filter(c => c.twoLetterCode === countryCode);
    if (country.length > 0) {
      const temp = country[0].topBanner;
      if (temp && temp?.published) {
        handleCloseBanner(false);
      } else {
        handleCloseBanner(true);
      }
      setContent(temp);
    }
  }, [countryCode]);

  useEffect(() => {
    const element = document.querySelector("#topBanner");
    if (element) {
      if (content?.backgroundColor) {
        element.style.background = content.backgroundColor;
      } else {
        element.style.background = "#FFFFFF";
      }
    }
  });

  function handleCloseBanner(value) {
    GlobalStore.update(s => {
      s.closeTopBanner = value;
    });
  }

  return (
    <div className="topBanner">
      {content?.published && (
        <div id="topBanner" className={`warningBanner ${closeTopBanner ? "hide" : ""}`}>
          <div className="wrap">
            <div
              className="warningText"
              style={{ "--color-text": content?.textColor || "#081d2c" }}
              dangerouslySetInnerHTML={{ __html: content.text }}
            />

            {content.buttonText && (
              <Link
                className="warningButton"
                to={slugToCountryPathname(content.buttonLink)}
                onClick={() => handleCloseBanner(true)}
                style={{
                  "--button-color-text": content?.buttonTextColor || "#FFF",
                  "--button-color": content?.buttonColor || "#00c3b5"
                }}>
                {content.buttonText}
              </Link>
            )}
            <div className="closeIcon" onClick={() => handleCloseBanner(true)}>
              <CloseIcon fill={content?.textColor} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
